<div class="footer-container" [ngClass]="{'bottom-container': setBot === true}">
    <div class="text">Dr. med. Joachim Schnell | Bahnhofstrasse 4 | 61273 Wehrheim | <a class="a-no-deco" href="tel:0608159074">Tel: 06081-59074</a></div>
</div>
